<template>
  <div :class="['axiome-logique-container', 'axiome-logique-max-qualified-cardinality']">
    <!--Affichage OnProperty-->
    <div :class="['display-flew-column', { 'display-flew-column-level0': level0 }]">
      <PropertyValue :values="onPropertyLiterals" :leftMargin="false" />
    </div>

    <template v-if="onPropertyBlanknodes.length">
      <AttributeBlankNode :blankNodes="onPropertyBlanknodes" :leftMargin="false" :braceDisplay="true"
        :showLanguageBadge="showLanguageBadge" />
    </template>

    <!--Affichage Operand-->
    <span :class="['axiome-logique-operand', ' ml-2', ' mr-2', { 'axiome-logique-operand-level0': level0 }]">max</span>

    <div :class="['display-flew-column', { 'display-flew-column-level0': level0 }]">
      <PropertyValue :values="maxQualifiedCardinalityLiterals" :leftMargin="false"
        :showLanguageBadge="showLanguageBadge" />
    </div>


    <!--Affichage onClass-->
    <div :class="['display-flew-column', { 'display-flew-column-level0': level0 }]">
      <PropertyValue :values="onClassLiterals" :leftMargin="false" />
      <template v-if="onClassBlanknodes.length">
        <AttributeBlankNode :blankNodes="onClassBlanknodes" :leftMargin="false" :braceDisplay="true"
          :showLanguageBadge="showLanguageBadge" />
      </template>
    </div>


    <!--Affichage onDataRange-->
    <div :class="['display-flew-column', { 'display-flew-column-level0': level0 }]">
      <PropertyValue :values="onDataRangeLiterals" :leftMargin="false" />
      <AttributeBlankNode :blankNodes="onDataRangeBlanknodes" :leftMargin="false" :braceDisplay="true"
        :showLanguageBadge="showLanguageBadge" />
    </div>
  </div>
</template>

<script>
export default {
  name: "LogicalAxiomeMaxQualifiedCardinality",
  computed: {
    maxQualifiedCardinalityLiterals() {
      let result = [];
      this.maxQualifiedCardinality.forEach(element => {
        result.push(...element.literals);
      });
      return result;
    }
  },
  props: {
    level0: {
      type: Boolean,
      default: false
    },
    maxQualifiedCardinality: {
      type: Array
    },
    onDataRangeLiterals: {
      type: Array
    },
    onDataRangeBlanknodes: {
      type: Array
    },
    onClassLiterals: {
      type: Array
    },
    onClassBlanknodes: {
      type: Array
    },
    onPropertyBlanknodes: {
      type: Array
    },
    onPropertyLiterals: {
      type: Array
    },
    showLanguageBadge: {
      type: Boolean,
      default: false
    }
  }
}
</script>
